import React from "react";
import { Route } from "react-router-dom";
import { RequireModuleAccess } from "../../app/session/RequireModuleAccess.js";
import DashboardPage from "./pages/DashboardPage.js";

export const analyticsRoutes = (
  <Route element={<RequireModuleAccess module="analytics" />}>
    <Route path="/" element={<DashboardPage />} />
  </Route>
);
